import { AUTH } from 'constants/api';
import axios from 'utils/axios';


export const userLoginRequest = async ({
    email,
    password,
    isRefresh = false,
    hasCaptcha = false,
    type = '',
    assessmentCode = '',
    requestCode = ''
}) => {
    let backendURL;
    switch (type) {
        case 'CANDIDATE':
            backendURL = AUTH.v1.candidateLoginRequest;
            break;
        case 'GUEST':
            backendURL = AUTH.v1.guestLoginRequest;
            break;
        default:
            backendURL = AUTH.v1.loginRequest;
            break;
    }

    const response = await axios.post(
        backendURL,
        {
            email,
            password,
            isRefresh,
            hasCaptcha,
            type,
            assessmentCode,
            requestCode
        },
        {
            withCredentials: true
        }
    );
    return response.data;
};

export const verifySession = async () => {
    const response = await axios.get(AUTH.v1.verifySession, {
        withCredentials: true
    });
    return response.data;
};

export const verifyLoginOtp = async ({
    email,
    otp,
    method,
    hasCaptcha = false,
    otpSessionKey,
    isKeepMeLogin = false,
    initialLoginToken = '',
    type = '',
    assessmentId = '',
    requestCode = ''
}) => {
    const response = await axios.post(AUTH.v1.verifyLoginOtp, {
        email,
        otp,
        method,
        hasCaptcha,
        otpSessionKey,
        isKeepMeLogin,
        initialLoginToken,
        type,
        assessmentId,
        requestCode
    });
    return response.data;
};

export const logout = async (data) => {
    const response = await axios.post(AUTH.v1.logout, data, { withCredentials: true });
    return response.data;
};

export const resendOtp = async (id, type = '') => {
    const response = await axios.post(AUTH.v1.resendOtp, { id, type }, { withCredentials: false });
    return response.data;
};

export const validateResetPasswordToken = async (resetPasswordToken, type = '') => {
    const response = await axios.get(AUTH.v1.validateResetPasswordToken, { params: { resetPasswordToken, type } });
    return response.data;
};

export const changePassword = async (userId, password, type = '', assessmentId = '', resetPasswordToken = '') => {
    const response = await axios.post(AUTH.v1.changePassword, { userId, password, type, assessmentId, resetPasswordToken });
    return response.data;
};

export const requestResetPassword = async ({ email, hasCaptcha = false, type = '', assessmentCode = '' }) => {
    const response = await axios.post(AUTH.v1.requestResetPassword, { email, hasCaptcha, type, assessmentCode });
    return response.data;
};

export const userValidateInitLogin = async (email, token, type = '', isAdmin = false) => {
    try {
        const response = await axios.post(AUTH.v1.verifyInitialLogin, {
            email,
            token,
            type,
            isAdmin
        });
        return response.data;
    } catch (e) {
        const error = new Error(e.message);
        error.code = e.code;
        throw error;
    }
};

export const validateInitialLoginInvitation = async (email, token, type = '', isAdmin = false) => {
    try {
        const response = await axios.post(AUTH.v1.validateInitialLogin, {
            email,
            token,
            type,
            isAdmin
        });
        return response.data;
    } catch (e) {
        const error = new Error(e.message);
        error.code = e.code;
        throw error;
    }
};

// set logged in user password
export const setPassword = async (password, assessmentId = '') => {
    try {
        const response = await axios.post(AUTH.v1.setPassword, { password, assessmentId }, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const reInitDeployment = async (deployment) => {
    try {
        const response = await axios.post(AUTH.v1.reInitDeployment, { deployment }, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
